enum HttpStatusCodes {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  /**
   * The BFF's answer when it cannot resolve a Healthie identity for the member. A property
   * of the session, not of the attempt, so it is identical on every retry — which is why
   * every retry switch below has to know about it.
   */
  PRECONDITION_FAILED = 412,
  UNPROCESSABLE_ENTITY = 422,
  /**
   * Healthie is throttling us, reported by the BFF as a `rate_limited` refusal. Terminal in
   * every retry switch below, and for a stronger reason than the rest of that list: a retry
   * does not merely fail again, it amplifies the condition the status reports.
   */
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504
}

// The host's copy (src/utils/HttpStatusCodes.ts) also exports a SUCCESS_CODES list; nothing in the
// messaging hooks uses it, so it is left out rather than shipped dead.
export { HttpStatusCodes }
